import PropTypes from 'prop-types';
import React, { useState } from 'react';
import useViewer from '@hooks/useViewer';
import useCartFromAPI from '@hooks/apiLegacy/useCartFromAPI';
import CartSummaryMobileBar from './CartSummaryMobileBar';
import CartSummaryMobileDrawer from './CartSummaryMobileDrawer';
import styled from 'styled-components';

const StyledMobileBar = styled.div`
    position: sticky;
    bottom: 0;
`;

const CartSummaryMobile = ({ navLabel, onNavClick, setCartHasErrors }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const { viewer } = useViewer();
    const { cart } = useCartFromAPI({ viewerId: viewer?.recordId });

    if (!cart) {
        return null;
    }

    return (
        <StyledMobileBar>
            <CartSummaryMobileBar
                cart={cart}
                isDrawerOpen={isDrawerOpen}
                navLabel={navLabel}
                onExpandToggleClick={() => setIsDrawerOpen(true)}
                onNavClick={() => onNavClick()}
            />

            <CartSummaryMobileDrawer
                navLabel={navLabel}
                isOpen={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                onNavClick={() => onNavClick()}
                setCartHasErrors={setCartHasErrors}
            />
        </StyledMobileBar>
    );
};

CartSummaryMobile.propTypes = {
    setCartHasErrors: PropTypes.func,
    navLabel: PropTypes.string.isRequired,
    onNavClick: PropTypes.func.isRequired,
};

export default CartSummaryMobile;
